<template>
  <v-app style="background-color: white" v-if="appUser">
    <ObservationReport />
    <!-- <Page2c/>
  <Page2d/> -->
  </v-app>
</template>
<script>
import ObservationReport from "./ObservationReport";
import store from "../../store";
// import Page2c from './Page2-1';
// import Page2d from './Page2-2';
export default {
  name: "page2",
  computed: {
    appUser() {
      return store.state.isLoggedIn;
    },
  },
  components: {
    ObservationReport,
    // Page2c,
    //  Page2d
  },
};
</script>
